module.exports = __webpack_public_path__ + "static/media/gemscape2.2070e8b1.svg";